<script>
import { formatBenchmarkRelativeLabel } from '@utils/clienteBenchmark'

export default {
  props: {
    retornoMensal: {
      type: Object,
      default: () => {
        return { 2020: {} }
      },
    },
    clienteBenchmarkMeta: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      headersMonthlyReturn: [
        'JAN',
        'FEV',
        'MAR',
        'ABR',
        'MAI',
        'JUN',
        'JUL',
        'AGO',
        'SET',
        'OUT',
        'NOV',
        'DEZ',
      ],
    }
  },
  computed: {
    relativeRowLabel() {
      return formatBenchmarkRelativeLabel(this.clienteBenchmarkMeta)
    },
    // Linhas exibíveis (um par por ano). Tira o Object.entries do template e
    // descarta valores não-objeto: a chave 'benchmark' chega como string e um ano
    // degradado pode chegar null (typeof null é 'object', daí o `&&`), o que
    // antes quebrava o render ao acessar v[1].rent / v[1][mes].
    linhasRetorno() {
      const meses = this.retornoMensal || {}
      return Object.entries(meses).filter(
        (entry) => entry[1] && typeof entry[1] === 'object'
      )
    },
  },
}
</script>

<template>
  <div class="table-container">
    <table class="tabela-retornos tabela-retornos-mensais table-new-ux-v1">
      <thead>
        <tr>
          <th class="no-border border-bottom-thead"></th>
          <th
            v-for="mes in headersMonthlyReturn"
            :key="mes"
            class="text-left text-dark no-border border-bottom-thead"
          >
            <strong>{{ mes }}</strong>
          </th>
          <th class="text-dark text-left no-border border-bottom-thead">
            <strong>Ano</strong>
          </th>
        </tr>
      </thead>
      <tbody class="double-items">
        <template v-for="(v, i) in linhasRetorno">
          <tr :key="'retorno-l1-' + i">
            <td class="text-left no-wrap">
              <strong>{{ v[0] }}</strong>
            </td>
            <td v-for="value in headersMonthlyReturn" :key="'l1-' + value" class="text-left">
              {{ v[1][value] ? v[1][value].rent : '-' }}
            </td>
            <td class="text-left">
              <strong>{{ v[1].rent || '-' }}</strong>
            </td>
          </tr>
          <tr :key="'retorno-l2-' + i">
            <td class="text-left no-wrap">
              <strong>{{ relativeRowLabel }}</strong>
            </td>
            <td v-for="value in headersMonthlyReturn" :key="'l2-' + value" class="text-left">
              {{ v[1][value] ? v[1][value].rent_relativa : '-' }}
            </td>
            <td class="text-left">
              <strong>{{ v[1].rent_relativa || '-' }}</strong>
            </td>
          </tr>
        </template>
      </tbody>
    </table>
  </div>
</template>

<style lang="sass">
.table-container
  width: 100%
  max-width: 100%
  min-width: 0
  overflow-x: auto

.tabela-retornos
  width: 100%
  white-space: nowrap
  border-collapse: collapse

  th
    padding: 10px 10px 10px 10px
    border-bottom: 1.25px solid var(--primary)
    font-size: 0.75rem !important

  td
    padding: 8px 10px !important
    min-width: 50px

  tbody tr:hover
    background-color: var(--gray-3) !important

    tbody tr:hover &
      background-color: var(--gray-3) !important
</style>
